import React from 'react';
import { Button, Text } from '@chakra-ui/react';
import MyProfile from '../../MyProfile';
import { useForm } from 'react-hook-form';
import {
	MyProfilePhoneForm,
	profilePhoneResolver,
} from './validation/profile.validation';
import { Loader, InputText } from '../../../../components';
import { useEditCurrentUser, useGetCurrentUser } from '../../queries';

export const PhoneForm = () => {
	const { data: userData, isLoading } = useGetCurrentUser();

	const {
		register,
		formState: { errors },
		handleSubmit,
		watch,
	} = useForm<MyProfilePhoneForm>({
		resolver: profilePhoneResolver,
	});

	const { mutate, isPending: isMutationLoading } = useEditCurrentUser();

	if (isLoading) {
		return <Loader centerHeight={'100dvh'} />;
	}

	const onSubmit = (data: MyProfilePhoneForm) => {
		if (userData) {
			mutate({
				firstName: userData.firstName,
				lastName: userData.lastName,
				phoneNumber: data.phone,
			});
		}
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<MyProfile>
				<InputText
					focusBorderColor="#08BB4B"
					{...register('phone')}
					type="tel"
					inputMode="numeric"
					autoComplete="tel-national"
					errorMsg={errors.phone?.message}
					bg={'#F1F4F9'}
					borderRadius={'10px'}
					h={'55px'}
					label={'Phone'}
					leftIcon={<Text color={'inherit'}>+1</Text>}
					placeholder={
						userData?.phoneNumber
							? String(userData.phoneNumber)
							: ''
					}
				/>
				<Button
					type={'submit'}
					h={'60px'}
					isDisabled={
						isMutationLoading || !(watch('phone')?.length === 10)
					}
					bg={'success'}
					color={'white'}>
					Change Phone
				</Button>
			</MyProfile>
		</form>
	);
};
